import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useSelector, useDispatch} from "react-redux";
import {NotificationManager} from "react-notifications";
import Button from "../../common/Button";
import {constants} from "../../common/constants/constants";
import ServerData from "../../common/serverData";
import house from "../../images/newDesign/insuranceHouse.svg";
import arrowInCircle from "../../images/newDesign/arrow_in_white_circle.svg";
import {StyledInsuranceOfferPage} from "./InsuranceOfferPage.styled";
import PaymentFlowContainer from "./PaymentFlowContainer";
import {UtilsApi} from "../../../client/tenants/utils.api";
import {resetTenant} from "../../store/tenant/slice";
import {useEffect} from "react";

export function InsuranceOfferPage({match, location}) {
    const client = new ServerData();
    const {buildingID, apartmentNumber, cartID} = match.params;
    const {tenantName, tenantEmail, tenantPhone} = location.state ?? {};

    const {t} = useTranslation();

    const dispatch = useDispatch();

    const history = useHistory();

    const ltr = useSelector(state => state.common.ltrEnabled);
    const tenantDetails = useSelector(state => state.tenant.details);

    useEffect(()=>{
        checkIfOpenedInIframe();
    },[]);

    async function scheduleCallAndContinue() {
        NotificationManager.success(t("payments.representativeWillContactYou"));
        await sendOffer();
        await handleContinueClick();
    }

    function checkIfOpenedInIframe() {
        //this is in case this page is opened in iframe (relevant for bitPage)
        if (window.self !== window.top) {
            window.postMessage('redirectToInsuranceOfferPage', '*');
        }
    }
    const sendOffer = async () => {
        const query = `?buildingID=${buildingID}`;
        const name = tenantDetails?.name || tenantName;
        const email = tenantDetails?.email || tenantEmail;
        const phone = tenantDetails?.phone || tenantPhone;
        const params = {
            sendTo: ["ariel@bllink.co", "ohad@bllink.co", "rayee@bllink.co"],
            title: `subject: New Tenant Insurance - building: <buildingAddress>  Apartment ${apartmentNumber}`,
            content: 'New insurance offer needed for tenant <br>' +
                'Building: <buildingAddress> <br>' +
                `Apartment Number: ${apartmentNumber} <br>` +
                `Name: ${name} <br>` +
                `Email: ${email} <br>` +
                `Phone: ${phone}`,
        };
        const utilsApi = new UtilsApi(client);
        return await utilsApi.postInternalEmail(constants.backendEndpoints.GENERIC_INTERNAL_EMAIL_ENDPOINT, query, params);
    }

    async function handleContinueClick() {
        dispatch(resetTenant());
        history.push(`/${constants.pages.orderStatusPage}/${cartID}`);
    }
    function onPageBack (){
        history.push(`/${constants.pages.orderStatusPage}/${cartID}`);
    }

    // TODO: add hideHeader parameter to container instead of 'insurance' and move all styling into the insurance page
    return (
        <PaymentFlowContainer
            title={t("payments.savingMoney")}
            subheader={t("payments.insuranceSavings")}
            insurance
            onPageBack={onPageBack}
        >
            <StyledInsuranceOfferPage ltr={ltr}>
                <div className="img-wrapper">
                    <img src={house}/>
                    <div className="img-info right">{t("payments.weSavedUpTo")}</div>
                    <div className="img-info left">
                        {t("payments.ourCostomersChoose")}
                    </div>
                </div>

                <div className="insurance-actions">
                    <div>{t("payments.checkHowMuchCanBeSaved")}</div>

                    <div className="btns-wrapper">
                        <Button onClick={scheduleCallAndContinue}>
                            {t("payments.scheduleCall")}
                            <img className="arrow" src={arrowInCircle} alt="arrow"/>
                        </Button>
                        <Button outlined className="btn-bordered" onClick={handleContinueClick}>
                            {t("payments.continueToConfirmPayment")}
                        </Button>
                    </div>
                </div>
            </StyledInsuranceOfferPage>
        </PaymentFlowContainer>
    );
}
